import React from 'react';
import PropTypes from 'prop-types';
import { uniqueId, isEmpty } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

import { SuddenIcon } from '../../../../assets/svg/Icon';

import { styles, StyledBadge } from '../../style';

const useStyles = makeStyles(styles);
export default function FlashfloodList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, handleFlashfloodDetailList, mobilemode, userIsLogin,
  } = props;

  const renderList = (dataList, boxClass) => (
    <>
      {dataList !== undefined && dataList.map((row) => (
        <Grid item key={uniqueId()}>
          <Box className={`${classes.listsBox} ${boxClass}`}>{row}</Box>
        </Grid>
      ))}
    </>
  );

  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewRisk}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                <IconButton
                  disabled={datas.count <= 0}
                  onClick={mobilemode ? null : handleFlashfloodDetailList(datas.dataTable)}
                >
                  <StyledBadge
                    id="main-flashflood-click"
                    badgeContent={datas.count}
                    overlap="circular"
                    color="secondary"
                  >
                    <SuddenIcon style={{ color: 'white' }} />
                  </StyledBadge>
                </IconButton>
              </Box>
              <Box display="flex" alignItems="center">
                <Box pl={1}>
                  <InfoIcon style={{ fontSize: 13, color: '#777' }} />
                </Box>
                <Box id="dialog_flashflood_forecast" p={1}>
                  { userIsLogin && (
                    <a id="navigate_model_flashflood" href="http://www.thaiwater.net/FlashFlood" target="_blank" rel="noopener noreferrer">
                      <Typography className={classes.titleBox}>{t('คาดการณ์น้ำท่วมฉับพลัน')}</Typography>
                    </a>
                  )}
                  { !userIsLogin && (
                    <Typography className={classes.titleBox}>{t('คาดการณ์น้ำท่วมฉับพลัน')}</Typography>
                  )}
                </Box>
                {/* <Box><Typography className={classes.timeBox}>{datas.time}</Typography></Box> */}
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_flashflood_forecast_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                {isEmpty(datas) ? null
                  : (
                    <>
                      {(datas.count <= 0)
                        ? (
                          <Grid item>
                            <Box
                              className={`${classes.listsBox}`}
                              style={{ backgroundColor: '#FFFFFF90', fontWeight: 'bold' }}
                            >
                              {t('ปกติ')}
                            </Box>
                          </Grid>

                        ) : renderList(datas.list, classes.yellow)}
                    </>
                  )}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
FlashfloodList.defaultProps = {
  mobilemode: false,
};

FlashfloodList.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
  handleFlashfloodDetailList: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
  userIsLogin: PropTypes.bool.isRequired,
};
